import { Injectable } from '@angular/core';

@Injectable()
export class OfferService {

  constructor() {}

  public getSmallOffer(offerSlug): any {
    const { application_slug, application_name } = this.getOffers().find(el => el.application_slug === offerSlug);
    return { application_slug, application_name };
  }

  public getFullOffer(offerSlug): any {
    return this.getOffers().find(el => el.application_slug === offerSlug);
  }

  public getActiveOffers() {
    return this.getOffers().filter(el => el.active);
  }

  public getOffers(): any {
    return [
      {
        application_slug: 'allya',
        application_name: 'Allya',
        description: `A Allya é a plataforma de parcerias e benefícios inteligentes que leva você onde quiser
         e te conecta a um mundo de possibilidades.`,
        image: 'assets/shared/img/offers/negocio_proposta_padr__o.ai-g82-4294966523.png',
        active: false // please keep this always false
      },
      {
        application_slug: 'banese-clube-mais',
        application_name: 'Banese Clube Mais',
        description: 'O Banese Clube Mais é o clube de descontos exclusivo para correntistas do banco Banese.',
        image: 'assets/shared/img/offers/negocio_proposta_padr__o.ai-g556-4294967283.png',
        active: true
      },
      {
        application_slug: 'comclub-concierge-medico',
        application_name: 'ComClub - Concierge Médico',
        description: 'Lorem ipsum dolor sit, consectet adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        image: 'assets/shared/img/offers/negocio_proposta_padr__o.ai-g656-4294967149.png',
        active: false
      },
      {
        application_slug: 'clube-estadao',
        application_name: 'Clube + Estadão',
        description: 'O Clube + Estadão é o clube de descontos exclusivo para assinantes do portal Estadão.',
        image: 'assets/shared/img/offers/negocio_proposta_padr__o.ai-g292-4294966563.png',
        active: false
      },
      {
        application_slug: 'clube-do-desconto-ike-assistencia',
        application_name: 'Clube do Desconto Ikê Assistência',
        description: 'Lorem ipsum dolor sit, consectet adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        image: 'assets/shared/img/offers/negocio_proposta_padr__o.ai-g536-4294966709.png',
        active: false
      }
    ];
  }
}
